import {useSyncExternalStore, type AnchorHTMLAttributes, type MouseEvent} from 'react';
import {PRODUCT_NAME} from '../src/product';

export const APP_BASE = import.meta.env.BASE_URL.replace(/\/$/, '');
export function navigate(path: string): void {
  if (!path.startsWith(`${APP_BASE}/`) && path !== APP_BASE) throw new Error(`Navigation must stay inside ${PRODUCT_NAME}.`);
  window.history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
export function usePath(): string {
  return useSyncExternalStore(listener => {
    window.addEventListener('popstate', listener);
    return () => window.removeEventListener('popstate', listener);
  }, () => window.location.pathname, () => `${APP_BASE}/`);
}
export function useSearch(): string {
  return useSyncExternalStore(listener => {
    window.addEventListener('popstate', listener);
    return () => window.removeEventListener('popstate', listener);
  }, () => window.location.search, () => '');
}
export function Link({href, onClick, ...props}: AnchorHTMLAttributes<HTMLAnchorElement> & {href: string}) {
  function click(event: MouseEvent<HTMLAnchorElement>): void {
    onClick?.(event);
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || props.target) return;
    event.preventDefault();
    if(!window.dispatchEvent(new CustomEvent('eightbots-auth-navigation',{cancelable:true,detail:{href}})))return;
    navigate(href);
  }
  return <a {...props} href={href} onClick={click}/>;
}
